import store from '@/store';
import { includes, intersection, forEach } from 'lodash';
import UserService from '@/services/UserService';
import ConfigService from '@/services/ConfigService';
import { slugData } from '@/utils';
import Constants from '@/constants.js';
import i18n from '@/locales';
// import initRecurly from '@/services/Recurly';

const isProd = process.env.NODE_ENV === 'production';

const truelifeCare = () => [
  {
    title: i18n.t('menuLeft.menu.dashboard'),
    key: 'careDashboard',
    icon: 'fe fe-bookmark',
    url: '/care-dashboard',
  },
  {
    title: i18n.t('menuLeft.menu.churchProfile'),
    key: 'churchProfile',
    icon: 'fe fe-home',
    url: '/churchProfile',
  },
  {
    title: i18n.t('menuLeft.menu.churchAccess'),
    key: 'churchAccess',
    icon: 'fe fe-user',
    url: '/churchAccess',
  },
  {
    title: i18n.t('menuLeft.menu.bulletinInsert'),
    key: 'bulletinInsertsCare',
    icon: 'fe fe-package',
    url: '/bulletinInsertsCare',
  },
  {
    title: i18n.t('menuLeft.menu.videoPlayer'),
    key: 'careVideoPlayer',
    icon: 'fe fe-tv',
    url: '/careVideoPlayer',
  },
];

const truelife = () => [
  {
    owner: 'Truelife.org',
    id: 'dashboard',
    items: [
      {
        title: i18n.tc('menuLeft.menu.dashboard'),
        key: 'dashboard',
        icon: 'fe fe-bookmark',
        url: '/dashboard',
      },
    ],
  },
  {
    owner: 'Promotion',
    items: [
      {
        title: i18n.tc('menuLeft.menu.orderCards'),
        key: 'orderCards',
        icon: 'fe fe-credit-card',
        url: '/orderCards',
      },
      {
        title: i18n.tc('menuLeft.menu.monthlyVideos'),
        key: 'monthlyVideos',
        icon: 'fe fe-video',
        url: '/monthlyVideos',
      },
      {
        title: i18n.tc('menuLeft.menu.bulletinInsert'),
        key: 'bulletinInserts',
        icon: 'fe fe-package',
        url: '/bulletinInserts',
      },
      {
        title: i18n.tc('menuLeft.menu.resources'),
        key: 'resources',
        icon: 'fe fe-hard-drive',
        url: '/resources',
      },
    ],
  },
  {
    owner: 'Church Management',
    id: 'churchMgr',
    items: [
      {
        title: i18n.tc('menuLeft.menu.profile'),
        key: 'profile',
        icon: 'fe fe-users',
        children: [
          {
            title: i18n.tc('menuLeft.menu.viewProfile'),
            key: 'viewProfile',
            isExternal: true,
            url: Constants.APP_URL + '/church/' + store.state.user.user.accountSlug,
          },
          {
            title: i18n.tc('menuLeft.menu.editProfile'),
            key: 'editProfile',
            url: '/editProfile',
          },
          {
            title: i18n.tc('menuLeft.menu.profileVideo'),
            key: 'profileVideo',
            url: '/profileVideo',
          },
        ],
      },
      {
        title: i18n.tc('menuLeft.menu.welcomeVideo'),
        // title: 'Invitation Video',
        key: 'welcomeVideo',
        icon: 'fe fe-play',
        url: '/welcome-video',
      },
      // {
      //   title: i18n.tc('menuLeft.menu.trackProgress'),
      //   key: 'trackYourProgress',
      //   icon: 'fe fe-wind',
      //   url: '/track-progress',
      // },
      {
        title: i18n.tc('menuLeft.menu.messages'),
        key: 'messages',
        icon: 'fe fe-message-circle',
        url: '/inbox',
      },
      {
        title: i18n.tc('menuLeft.menu.campuses'),
        key: 'campuses',
        icon: 'fe fe-map-pin',
        url: '/campuses',
      },
    ],
  },
  {
    owner: 'Jesus Story Challenge',
    id: 'syjs',
    items: [
      // {
      //   // title: i18n.tc('menuLeft.menu.testimonials'),
      //   title: 'Under Construction',
      //   key: 'testimonials',
      //   icon: 'fe fe-film',
      //   url: '/testimonials',
      // },
      {
        // title: i18n.tc('menuLeft.menu.setupShareStory'),
        title: 'Invite Jesus Stories',
        key: 'setupShareStory',
        icon: 'fe fe-book',
        url: '/setup-share-story',
        // url: '/system/coming',
      },
      {
        // title: i18n.tc('menuLeft.menu.connectRequest'),
        title: 'Connections',
        key: 'connectRequest',
        icon: 'fe fe-book',
        url: '/connect-request',
      },
      {
        title: 'Church Directory',
        key: 'jesusStories',
        icon: 'fe fe-codepen',
        url: '/jesus-stories',
      },
    ],
  },
  {
    owner: 'Moderators',
    items: [
      {
        title: 'Invite Moderators',
        key: 'churchInviteModerator',
        icon: 'fe fe-book',
        url: '/invite-moderator',
      },
      {
        title: 'Church Moderators',
        key: 'churchModerators',
        icon: 'fe fe-book',
        url: '/church-moderators',
      },
    ],
  },
  {
    owner: 'Education',
    items: [
      // {
      //   title: 'Subscriptions',
      //   key: 'subscriptions',
      //   icon: 'fe  fe-radio',
      //   url: '/subscriptions',
      // },
      {
        title: i18n.tc('menuLeft.menu.studyGuides'),
        key: 'studyGuides',
        icon: 'fe fe-book',
        url: '/studyGuides',
      },
      {
        title: i18n.tc('menuLeft.menu.videoPlayer'),
        key: 'videoPlayer',
        icon: 'fe fe-tv',
        url: '/videoPlayer',
      },
      {
        title: i18n.tc('menuLeft.menu.evangelismBootcamp'),
        key: 'evangelismBootcamp',
        icon: 'fe fe-codepen',
        url: '/evangelism-bootcamp',
      },
    ],
  },
  {
    owner: 'Store',
    items: [
      {
        title: 'Order Products',
        key: 'orderProducts',
        icon: 'fe fe-shopping-cart',
        url: '/orderProducts',
      },
    ],
  },
];

const accountMenuData = () => [
  {
    title: i18n.tc('menuLeft.menu.AccountInvoicePayment'),
    key: 'account',
    url: '/account',
    icon: 'fe fe-radio',
  },
  {
    title: i18n.tc('menuLeft.menu.paymentInfo'),
    key: 'paymentInfo',
    url: '/paymentInfo',
    icon: 'fe fe-credit-card',
  },
  //  {
  //    title: 'Special Offers',
  //    key: 'specialOffers',
  //    icon: 'fe fe-clipboard',
  //    url: '/specialOffers',
  //  },
  // {
  //   title: i18n.tc('menuLeft.menu.supportCenter'),
  //   key: 'supportCenter',
  //   icon: 'fe fe-life-buoy',
  //   url: '/support',
  // },
  {
    title: 'Support Request',
    key: 'supportRequest',
    icon: 'fe fe-life-buoy',
    url: '/support',
    isExternal: true,
  },
];

const adminData = () => ({
  careVideo: [
    {
      title: 'Care Video',
      key: 'adminCareVideo',
      icon: 'fe fe-map-pin',
      url: '/admin/care_video',
    },
  ],
  careCategory: [
    {
      title: 'Care Category',
      key: 'adminCareCategory',
      icon: 'fe fe-map-pin',
      url: '/admin/care_category',
    },
  ],
  careSpkeakerBio: [
    {
      title: 'Care Speaker Bio',
      key: 'adminCareSpeakerBio',
      icon: 'fe fe-map-pin',
      url: '/admin/care_speaker_bio',
    },
  ],
  user: [
    {
      title: 'User',
      key: 'adminUser',
      icon: 'fe fe-user',
      url: '/admin/user',
    },
    {
      title: 'Free',
      key: 'adminFreeUser',
      icon: 'fe fe-user',
      url: '/admin/free_user',
    },
    {
      title: 'Paster Sign Up',
      key: 'adminPasterSignUp',
      icon: 'fe fe-user',
      url: '/admin/paster_signup',
    },
    {
      title: 'QR Cord',
      key: 'qrCode',
      icon: 'fe fe-user',
      url: '/admin/qr_code',
    },
  ],
  moderator: [
    {
      title: 'Moderators',
      key: 'adminModerators',
      icon: 'fe fe-user',
      url: '/admin/moderators',
    },
    {
      title: 'Moderator Activities',
      key: 'adminModeratorActivities',
      icon: 'fe fe-user',
      url: '/admin/moderator-activities',
    },
  ],
  account: [
    {
      title: 'Account',
      key: 'adminAccount',
      icon: 'fe fe-radio',
      url: '/admin/account',
    },
    {
      title: 'Create',
      key: 'adminCreateAccount',
      icon: 'fe fe-plus-circle',
      url: '/admin/account/create',
    },
  ],
  location: [
    {
      title: 'Location',
      key: 'adminLocation',
      icon: 'fe fe-map-pin',
      url: '/admin/location',
    },
  ],
  category: [
    {
      title: 'Category',
      key: 'adminCategory',
      icon: 'fe fe-archive',
      url: '/admin/category',
    },
  ],
  aiControl: [
    {
      title: 'Ai Control',
      key: 'aiControl',
      icon: 'fe fe-lock',
      url: '/admin/ai_control',
    },
  ],
  pages: [
    {
      title: 'Pages',
      key: 'adminPages',
      icon: 'fe fe-layout',
      url: '/admin/pages',
    },
  ],
  monthlyPages: [
    {
      title: 'Monthly Videos',
      key: 'adminMonthlyPages',
      icon: 'fe fe-layout',
      url: '/admin/monthly_pages',
    },
  ],
  post: [
    {
      title: 'Post',
      key: 'adminPost',
      icon: 'fe fe-link-2',
      url: '/admin/post',
    },
  ],
  cardOrder: [
    {
      title: 'New Order',
      key: 'AdminCardOrderNew',
      icon: 'fe fe-credit-card',
      url: '/admin/cardOrder/new',
    },
    {
      title: 'Orders',
      key: 'AdminCardOrders',
      icon: 'fe fe-credit-card',
      url: '/admin/cardOrder',
    },
    {
      title: 'Order History',
      key: 'AdminCardOrderHistory',
      icon: 'fe fe-credit-card',
      url: '/admin/cardOrder/history',
    },
  ],
  shareStory: [
    {
      title: i18n.tc('menuLeft.menu.shareStory'),
      key: 'shareYourStory',
      icon: 'fe fe-video',
      url: '/admin/share-story',
    },
  ],
  videos: [
    {
      title: 'Videos',
      key: 'adminVideos',
      icon: 'fe fe-video',
      url: '/admin/videos',
    },
    {
      // title: i18n.tc('menuLeft.menu.videoReview'),
      title: 'Video Review',
      key: 'videoReview',
      icon: 'fe fe-truck',
      url: '/admin/video-review',
    },
    {
      title: 'Upload Video',
      key: 'adminVideoUpload',
      icon: 'fe fe-video',
      url: '/admin/videoUpload',
    },
  ],
  store: [
    {
      title: 'Products',
      key: 'adminProducts',
      icon: 'fe fe-shopping-bag',
      url: '/admin/store/products',
    },
    {
      title: 'Product Categories',
      key: 'AdminProductCategories',
      icon: 'fe fe-grid',
      url: '/admin/store/categories',
    },
  ],
});

const individual = () => [
  {
    owner: 'Truelife.org',
    items: [
      {
        title: i18n.t('menuLeft.menu.dashboard'),
        key: 'individualDashboard',
        icon: 'fe fe-bookmark',
        url: '/individual-dashboard',
      },
      // {
      //   title: i18n.tc('menuLeft.menu.orderCards'),
      //   key: 'individualOrderCards',
      //   icon: 'fe fe-credit-card',
      //   url: '/individual/orderCards',
      // },
      {
        title: i18n.tc('menuLeft.menu.evangelismBootcamp'),
        key: 'evangelismBootcamp',
        icon: 'fe fe-codepen',
        url: '/evangelism-bootcamp',
      },
      {
        // title: i18n.tc('menuLeft.menu.shareStory'),
        title: 'Jesus Story Challenge',
        key: 'shareYourStory',
        icon: 'fe fe-video',
        url: '/share-your-story',
      },
    ],
  },
  {
    owner: 'Promotion',
    items: [
      {
        title: i18n.tc('menuLeft.menu.orderCards'),
        key: 'orderCards',
        icon: 'fe fe-credit-card',
        url: '/orderCards',
      },
    ],
  },
  {
    owner: 'Store',
    items: [
      {
        title: 'Order Products',
        key: 'orderProducts',
        icon: 'fe fe-shopping-cart',
        url: '/orderProducts',
      },
    ],
  },
];

const freeEvangelismMenuData = () => [
  {
    owner: 'Truelife.org',
    id: 'dashboard',
    items: [
      {
        title: i18n.tc('menuLeft.menu.dashboard'),
        key: 'dashboard',
        icon: 'fe fe-bookmark',
        url: '/dashboard',
      },
      {
        title: i18n.tc('menuLeft.menu.evangelismBootcamp'),
        key: 'evangelismBootcamp',
        icon: 'fe fe-codepen',
        url: '/evangelism-bootcamp',
      },
    ],
  },
  {
    owner: 'Church Management',
    id: 'churchMgr',
    items: [
      {
        title: i18n.tc('menuLeft.menu.profile'),
        key: 'profile',
        icon: 'fe fe-users',
        children: [
          {
            title: i18n.tc('menuLeft.menu.viewProfile'),
            key: 'viewProfile',
            isExternal: true,
            url: Constants.APP_URL + '/church/' + store.state.user.user.accountSlug,
          },
          {
            title: i18n.tc('menuLeft.menu.editProfile'),
            key: 'editProfile',
            url: '/editProfile',
          },
          {
            title: i18n.tc('menuLeft.menu.profileVideo'),
            key: 'profileVideo',
            url: '/profileVideo',
          },
        ],
      },
      {
        title: i18n.tc('menuLeft.menu.messages'),
        key: 'messages',
        icon: 'fe fe-message-circle',
        url: '/inbox',
      },
      {
        title: i18n.tc('menuLeft.menu.campuses'),
        key: 'campuses',
        icon: 'fe fe-map-pin',
        url: '/campuses',
      },
    ],
  },
  {
    owner: 'Account',
    id: 'account',
    items: [
      {
        title: 'Upgrade',
        key: 'upgradeMembership',
        icon: 'fe fe-book',
        url: '/upgrade-information',
      },
    ],
  },
];

export default async function getMenuData() {
  let menuItems = [];

  try {
    const resp = await ConfigService.getConfig();
    if (resp && resp.length) {
      /* eslint-disable */
      const config = resp.reduce((a, c) => ((a[c.key] = c.value), a), {});
      store.commit('CHANGE_SETTING', { setting: 'configVars', value: config });
    }
  } catch (e) {
    console.log(e);
  }

  const user = store.state.user.user;

  if (includes(user.role, 'admin')) {
    forEach(adminData(), (items, owner) => {
      if (items[0].key == 'adminVideos') {
        items[0].badge_number = user.waitingVideos;
      }
      menuItems.push({
        owner: slugData(owner, ' '),
        items,
      });
    });
    store.dispatch('updateRole', true);
    return {
      menuItems,
      accountData: [],
    };
  } else {
    let resp = {};
    if (!includes(user.role, 'individual')) {
      resp = await UserService.doGetUserInfo();
      // if (isEmpty(resp)) {
      //   router.push({ name: '404' });
      // }
      store.dispatch('updateChurchId', resp.id);
    }
    let accountData = accountMenuData();
    const truelifeMenu = truelife();
    // await initRecurly();
    // if (!isEmpty(resp.account_slug)) {
    //   truelifeMenu[1].items[0].children[0].url = `${Constants.APP_URL}/church/` + resp.account_slug;
    // }

    if (!store.state.user.needToPay) {
      if (includes(user.role, 'individual') || includes(user.role, 'evangelism')) {
        const userInfos = await UserService.doGetUserInfo1();
        // eslint-disable-next-line camelcase
        const { moderator, firstname, lastname, church_name, membership, location, photo_url, intro_video_slug, shipping_address } = userInfos;

        if (isProd && includes(user.role, 'evangelism') && !includes(user.role, 'free_evangelism')) {
          if (!membership || membership.state === 'past_due') {
            return {
              accountData: [accountData[1]],
            };
          }
        }

        if (!church_name) {
          truelifeMenu[2].items.find(i => i.key === 'campuses').badge = {
            icon: 'fe fe-alert-triangle',
            color: '#ff0000',
            hover: 'Add church location to map.',
          };
        }

        store.dispatch('updateUser', {
          user: {
            ...store.state.user.user,
            moderator,
            firstname,
            lastname,
            photo_url,
            location,
            church_name,
            membership,
            intro_video_slug,
            invite_video: resp.invite_video,
            shippingInfo: shipping_address,
          },
        });

        const isModerator = moderator && ['approved'].includes(moderator.status);
        const moderatorMenu = {
          // title: i18n.tc('menuLeft.menu.becomeModerator'),
          title: 'Become a Moderator',
          key: 'becomeModerator',
          icon: 'fe fe-truck',
          url: '/become-moderator',
        };

        const videoReviewMenu = {
          // title: i18n.tc('menuLeft.menu.videoReview'),
          title: 'Video Review',
          key: 'videoReview',
          icon: 'fe fe-truck',
          url: '/video-review',
        };
        if (includes(user.role, 'individual')) {
          let individualMenu = individual();
          let items = individualMenu[0].items;

          // if (!user.churchStatus || user.churchStatus === 'declined') {
          items.push({
            // title: i18n.tc('menuLeft.menu.connectToChurch'),
            title: 'Connect to Church',
            key: 'connectToChurch',
            icon: 'fe fe-book',
            url: '/connect-to-church',
          });
          // }

          if (isModerator) {
            items.push(videoReviewMenu);
          } else if (moderator && moderator.status === 'invited') {
            items.push(moderatorMenu);
          }

          menuItems = [...menuItems, ...individualMenu];
          store.dispatch('updateRole', false);
        }

        if (includes(user.role, 'evangelism')) {
          // let items = truelifeMenu[0].items;
          // items.push(isModerator ? videoReviewMenu : moderatorMenu);

          menuItems = truelifeMenu;
          forEach(menuItems, items => {
            if (items.id == 'syjs' && items.items[1].key == 'connectRequest') {
              items.items[1].badge_number = user.newConnections;
            }
          });
          store.dispatch('updateRole', true);
        }
      }

      if (includes(user.role, 'care')) {
        menuItems.push({
          owner: 'Truelife Care',
          items: truelifeCare(),
        });
        store.dispatch('updateRole', true);
      }

      if (intersection(user.role, ['website', 'discipleship']).length > 0) {
        menuItems.push({
          owner: 'Truelife',
          items: [...truelifeCare(), ...truelifeMenu],
        });
        store.dispatch('updateRole', true);
      }
    }

    if (includes(user.role, 'free_evangelism')) {
      menuItems = freeEvangelismMenuData();
      forEach(menuItems, items => {
        if (items.id == 'syjs' && items.items[1].key == 'connectRequest') {
          items.items[1].badge_number = user.newConnections;
        }
      });
      return {
        menuItems,
      };
    }

    accountData[2].url = `${Constants.APP_URL}/pages/contact-truelife-org?from=` + (includes(user.role, 'individual') ? 'syjs' : 'pastor');

    if (includes(user.role, 'individual')) {
      accountData = accountData.filter(m => !['supportCenter', 'account'].includes(m.key));
    }

    return {
      menuItems,
      accountData,
    };
  }
}
